import * as React from 'react';

function AboveProficiencyTarget(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={62} height={12} viewBox="0 0 62 12" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M31.5 1.129L35.335 3.5H59a2 2 0 012 2v1a2 2 0 01-2 2H35.24l-3.83 2.371a.866.866 0 01-.91 0L26.667 8.5H3a2 2 0 01-2-2v-1a2 2 0 012-2h23.757l3.834-2.371a.866.866 0 01.91 0z"
          stroke="var(--cds-color-grey-200)"
        />
        <path
          d="M31.3 3.077L33.762 4.6a.5.5 0 01.237.4H58a1 1 0 010 2H33.993l-.002.032a.51.51 0 01-.233.337l-2.512 1.554a.52.52 0 01-.546 0L28.239 7.4A.501.501 0 0128 6.94V5.05a.498.498 0 01.241-.419l2.513-1.554a.52.52 0 01.545 0z"
          fill="var(--cds-color-yellow-200)"
        />
      </g>
    </svg>
  );
}

export default AboveProficiencyTarget;
